import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import PropertyList from "../components/Header/Property/PropertyList";

/**
 * Full properties listing: search, type/city filters, pagination.
 * Home page links here via "View All".
 */
const PropertiesListingPage = () => {
  const theme = useSelector((state) => state.themeValue.colors);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "90vh",
        bgcolor: theme?.screen_background || "#fff",
        pt: { xs: 1, sm: 2 },
        pb: 4,
      }}
    >
      <PropertyList variant="listing" />
    </Box>
  );
};

export default PropertiesListingPage;
